import { gql } from '@apollo/client';
import { WEB_USER_FRAGMENT } from './WebUserFragments';
import { WebUser } from 'types/User';

export const UPDATE_ONBOARDING_COMPLETION_MUTATION = gql`
  mutation updateOnBoardingCompletionMutation(
    $input: UpdateOnBoardingCompletionInput!
  ) {
    updateOnBoardingCompletion(input: $input) {
      me {
        ...webUserFields
      }
    }
  }
  ${WEB_USER_FRAGMENT}
`;

export type UpdateOnBoardingCompletionOutput = {
  updateOnBoardingCompletion: {
    me: WebUser;
  };
};
